import * as amplitude from "@amplitude/analytics-browser";
import { useEffect } from "react";
import { Outlet, Route } from "react-router-dom";
import { FeatureFlagProvider } from "src/components/Providers/FeatureFlagProvider";
import { UserContextProvider } from "src/hooks/useUser";
import * as Url from "src/services/url";
import { AccountLookup } from "./public/accountLookup";
import { Availability } from "./public/availability";
import { Landing } from "./public/Landing";
import { PageRedirect } from "./public/PageRedirect";

function AmplitudeInstrumentation({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const identify = new amplitude.Identify();

    // "Don't set the user ID if there isn't one": https://amplitude.com/docs/get-started/identify-users
    amplitude.identify(identify, {});
  }, []);

  return <>{children}</>;
}

export const UnauthorizedAvelaRoutes = (
  <Route
    element={
      <UserContextProvider>
        <FeatureFlagProvider>
          <AmplitudeInstrumentation>
            <Outlet />
          </AmplitudeInstrumentation>
        </FeatureFlagProvider>
      </UserContextProvider>
    }
  >
    <Route path={Url.Parent.Availability.path} element={<Availability />} />
    <Route path={Url.Parent.Landing.path} element={<Landing />} />
    <Route path={Url.Parent.AccountLookup.path} element={<AccountLookup />} />
    <Route path={Url.pageRedirectPath} element={<PageRedirect />} />
  </Route>
);
